
export class User {
  public id : string;
  public username : string;
  public first_name : string;
  public last_name : string;
  public email : string;
  public username__icontains : string;
  public first_name__iconstains : string;
  public last_name__icontains : string;
  public email__icontains : string;
  public is_superuser : string;
  public is_staff : string;
  public is_active : string;
  public networks: any[];
  public kycs: any[];
  public clients: any[];
  public role_id: any;
  public access_id: any;
  public password: string;
}
